import { useState } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { List, Divider, Button, Typography, Space, InputNumber, Statistic } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { formatTicketNumber, showNotificationTopEnd } from '../../../util/utils';
import dayjs from 'dayjs';

import ModalPersonalInfo from './ModalPersonalInfo/ModalPersonalInfo';
import ModalLuckMachine from './ModalLuckMachine/ModalLuckMachine';
import VirtualizedTickets from './VirtualizedTickets/VirtualizedTickets';

import './Boletos.css';


const { Title, Text } = Typography;
const { Timer } = Statistic;

export default function Boletos(props) {
    const { data, refresh, setRefresh } = props;
    const [selectedTickets, setSelectedTickets] = useState([]);
    const [searchedTicket, setSearchedTicket] = useState(null);
    const [modalPersonalInfoVisible, setModalPersonalInfoVisible] = useState(false);
    const [modalLuckMachineVisible, setModalLuckMachineVisible] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const deadline = dayjs(data?.lottoDate).valueOf();


    const handleRefresh = () => {
        setRefresh(!refresh);
    };


    const handleCleanSelectedTickets = () => {
        setSelectedTickets([]);
    };


    const addTicket = (ticket) => {
        // Si se encuentra, lo removemos, sino lo agregamos
        if (selectedTickets.includes(ticket)) {
            setSelectedTickets(selectedTickets.filter(t => t !== ticket));
        } else {
            setSelectedTickets([...selectedTickets, ticket]);
        }
    };


    const mergeTicketsList = (ticketsToMerge) => {
        // Unimos ambas listas
        const mergedTickets = [...selectedTickets, ...ticketsToMerge];

        // Eliminamos duplicados (ejemplo: por ticketNumber)
        const uniqueTickets = mergedTickets.filter(
            (ticket, index, self) =>
                index === self.findIndex(t => t.ticketNumber === ticket.ticketNumber)
        );

        setSelectedTickets(uniqueTickets);
    };


    const addSearchedTicket = (ticket) => {
        if (ticket) {
            addTicket(ticket);
            setSearchedTicket(null);
        }
    };


    const onHandleSearch = (searchNumber) => {
        // const ticketS = data?.tickets?.find(ticket => ticket.ticketNumber === searchNumber);
        const ticketS = data?.tickets?.find(ticket =>
            ticket.ticketNumber === searchNumber ||
            ticket.subTickets.some(sub => sub.subTicketNumber === searchNumber)
        ) ?? null;

        setSearchedTicket(ticketS);
    }


    const handleApartar = () => {
        setModalPersonalInfoVisible(true);
    }


    const onFinish = () => {
        showNotificationTopEnd('warning', 'El sorteo ha finalizado');
        setIsFinished(true);
    }


    const scalaVirtualizedList = (value) => {
        const count = value?.length || 0;

        if (count >= 1000) {
            return '600px';
        }
        if (count >= 700) {
            return '500px';
        }
        if (count >= 400) {
            return '400px';
        }
        if (count >= 30) {
            return '300px';
        }
        return '100px';
    };


    return (
        <Fragment>
            <div className="ticket-header-section">
                <Title level={1} className="ticket-main-title">
                    SELECCIONA TUS BOLETOS
                </Title>
                <Title level={2} className="ticket-main-sub-title">
                    o intenta con la maquina de la suerte
                </Title>
                <br />
                <Button className='ticket-luck-button' size="large" disabled={isFinished} onClick={() => setModalLuckMachineVisible(true)}>🍀 MÁQUINA DE LA SUERTE 🍀</Button>
                <ModalLuckMachine
                    visible={modalLuckMachineVisible}
                    onClose={() => {
                        setModalLuckMachineVisible(false);
                    }}
                    selectedTickets={selectedTickets}
                    data={data}
                    mergeTicketsList={mergeTicketsList}
                />
                <div>
                    <InputNumber className='ticket-search-input' placeholder="Buscar Ticket" size="large" value={searchedTicket?.ticketNumber} onChange={onHandleSearch} />
                    {searchedTicket && (
                        <>
                            <br /><br />
                            <div className='searched-ticket-section'>
                                <Text strong>Boleto Encontrado</Text>
                                <br />
                                <Button size="small" className={`minw-110 little-ticket-button ${selectedTickets.includes(searchedTicket) ? "selected" : ""}`} onClick={() => addSearchedTicket(searchedTicket)}>{formatTicketNumber(searchedTicket.ticketNumber, data?.ticketAmount)}</Button>
                            </div>
                            <Text style={{ color: 'rgba(0,0,0,0.45)' }} strong>* Haz clic en el boleto para agregarlo a la lista</Text>
                        </>
                    )}
                    <br /><br />
                    {selectedTickets.length > 0 && (
                        <div className='selected-tickets-section'>
                            <Text strong>{selectedTickets.length} Boletos Seleccionados</Text>
                            <div id="scrollableDivSelectedTickets" style={{ height: 70, overflow: "auto" }}>
                                <InfiniteScroll
                                    dataLength={selectedTickets.length}
                                    scrollableTarget="scrollableDivSelectedTickets"
                                >
                                    <List
                                        grid={{
                                            gutter: 10,
                                            xs: 4,
                                            sm: 5,
                                            md: 7,
                                            lg: 8,
                                            xl: 12,
                                            xxl: 14,
                                        }}
                                        dataSource={selectedTickets}
                                        renderItem={item => {
                                            return (
                                                <List.Item className='tickets-item'>
                                                    <Button className={`w-100 little-ticket-button selected`} size="small" onClick={() => addTicket(item)}>{formatTicketNumber(item.ticketNumber, data?.ticketAmount)}</Button>
                                                </List.Item>
                                            )
                                        }}
                                    />
                                </InfiniteScroll>
                            </div>

                            <div id="scrollableDivTicketsList" style={{ height: 90, overflow: "auto" }}>
                                <InfiniteScroll
                                    dataLength={selectedTickets.length}
                                    scrollableTarget="scrollableDivTicketsList"
                                >
                                    {selectedTickets.map(item => {
                                        const subs = item.subTickets.map(sub => formatTicketNumber(sub.subTicketNumber, data?.ticketAmount)).join(", ");
                                        return (
                                            <div key={item.ticketNumber}>
                                                <Text style={{ fontSize: "10px" }} strong>{formatTicketNumber(item.ticketNumber, data?.ticketAmount)} </Text>
                                                <Text style={{ fontSize: "10px" }}>({subs})</Text>
                                            </div>
                                        );
                                    })}
                                </InfiniteScroll>
                            </div>

                            <br />
                            <Text style={{ color: 'rgba(0,0,0,0.45)', fontSize: "12px" }} strong>* Haz clic en el boleto para eliminarlo de la lista</Text>
                            {/* <Text>
                                {selectedTickets.map(item => {
                                    const subs = item.subTickets.map(sub => sub.subTicketNumber).join(", ");
                                    return `${item.ticketNumber} (${subs})`;
                                }).join(", ")}
                            </Text> */}
                            <br />
                            <Button disabled={isFinished} size="large" className='apartar-button' onClick={handleApartar}>¡Apartar Ahora!</Button>
                            <ModalPersonalInfo
                                visible={modalPersonalInfoVisible}
                                onClose={() => {
                                    setModalPersonalInfoVisible(false);
                                }}
                                data={data}
                                selectedTickets={selectedTickets}
                                handleRefresh={handleRefresh}
                                handleCleanSelectedTickets={handleCleanSelectedTickets}
                            />
                        </div>
                    )}
                </div>
                <br />
                <br />
                <div>
                    <Space>
                        <Text strong>Blanco - Disponible</Text>
                        <Button disabled size="small" className='ticket-clean-button-explain'></Button>
                    </Space>
                    <Divider type="vertical" />
                    <Space>
                        <Text strong>Verde - Seleccionado</Text>
                        <Button disabled size="small" className='ticket-selected-button-explain'></Button>
                    </Space>
                    <br />
                    <br />
                    <Text style={{ color: 'rgba(0,0,0,0.45)' }} strong>* Los boletos que ya estén apartados o pagados no se mostrarán en la lista.</Text>
                </div>
            </div>

            <br />
            <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
                <Text style={{ fontSize: '18px' }} strong>Tiempo restante para terminar el sorteo</Text>
                <Timer
                    type="countdown"
                    value={deadline}
                    onFinish={onFinish}
                    format="D [días] HH [hrs] mm [min] ss [seg]"
                    valueStyle={{ color: '#a63827', fontWeight: 'bold' }}
                />
            </div>

            <div className="virtualized-container"
                style={{ height: scalaVirtualizedList(data?.tickets), width: '100%', display: 'block', transition: 'height 0.3s ease' }}>
                <VirtualizedTickets
                    tickets={data?.tickets || []}
                    selectedTickets={selectedTickets}
                    addTicket={addTicket}
                    data={data}
                />
            </div>
        </Fragment >
    );
}